import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { ProductEditService } from '../../service/product-edit/product-edit.service';

@Component({
	selector: 'app-product-edit',
	templateUrl: './product-edit.component.html',
	providers: [
		ProductEditService,
		HttpModule
	]
})
export class ProductEditComponent implements OnInit {

	private token;
	private sub: any;
	public permissoes: any[] = [];
	product: FormGroup;
	ID: string;
	Nome: string;
	Ativo: boolean;

	constructor(fb: FormBuilder, private productEditService: ProductEditService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.product = fb.group({
			'ID': '',
			'Nome': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.productEditService.loadProduct(this.token, this.ID).subscribe(result => {
				var updateProduct = result.Result;
				this.product.setValue({
					ID: updateProduct.ID,
					Nome: updateProduct.Nome,
					Ativo: updateProduct.Ativo
				});
			})
		}, error => {
			console.log(error);
			
		});
	}

	editProduct(value: any) {
		this.productEditService.editProduct(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Produtos e Serviços editado com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/produto-servico');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/produto-servico');
	}

}



// WEBPACK FOOTER //
// ./src/app/product/component/product-edit/product-edit.component.ts